import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_5lgyja8g: FaireBrandEntity = {
  token: "b_5lgyja8g",
  type: "brand",
  name: "a. favorite design",
  avatarUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/83444a03d3a05583377db4d15b2617b03cce1501cb71443d79de32a84b000d40/1563808069.jpg",
  bannerUrl:
    "https://cdn.faire.com/fastly/063f1c8e0a105f9d352f78eb0c96d5ff49773d47417f756b25ca6986f2ed66a4.jpeg",
  logoUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/83444a03d3a05583377db4d15b2617b03cce1501cb71443d79de32a84b000d40/1563808069.jpg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/063f1c8e0a105f9d352f78eb0c96d5ff49773d47417f756b25ca6986f2ed66a4.jpeg",
  location: "Chicago, IL, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 71,
  isTopShop: true,
  isInsider: true,
  description:
    "Our mission at a. favorite design is to encourage long distance warm fuzzies through snail mail. Good design, often sweet & sometimes cheeky sentiments are our specialty. a. favorite design was created in 2005 by graphic designer turned letterpress artist, Amber Favorite. Amber has always had a passion for design and typography. This passion fueled her desire to learn the art of letterpress printing & create a line of greeting cards & stationery. Amber's love for vintage typewriters, wood block type, old signage, flea markets, her sweet home chicago, soulmate Tom, and the magical number 33 are prevalent throughout her work. She is a believer in the magic of snail mail and the idea that a long distance warm fuzzie can change someon’s day or maybe even a life. ",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:00.214Z",
    importedBy: "entity-db-cli",
  },
};
